import * as TK from 'components/Header/HeaderNavigation/translations/header-navigation.locale.constants';

export const headerNavigationCommonLocale = {
  [TK.VIEW_ALL_PRODUCTS]: 'View all products',
  [TK.BANNER_ALT]: 'Gift under 50',
};
